// extracted by mini-css-extract-plugin
module.exports = {"reportEventButton":"reportEventButton-3prV2","flagIcon":"flagIcon-2q4KQ"};